<template lang="pug">
  .post-comment
    img.post-comment__user-icon(
      :src="comment.author_logo"
    )
    .post-comment__body
      .post-comment__user-name {{ comment.author }}
        .post-comment__date {{ postTime }}
          .post-counter
            img.post-counter__icon(src="../../assets/images/icon-like.svg")
            .post-counter__count {{ comment.likes }}
      .post-comment__text(v-html="trimmedText")
      .post-body__show-more(
        v-if="trimTextLength < comment.text.length"
        @click="trimText = !trimText"
      ) {{ trimText ? 'Подробнее' : 'Скрыть' }}
    <!--template(v-if="Number(comment.children) > 2 && !showReComment")-->
      <!--.post-re-comment-prev(@click="showReComment = true")-->
        <!--img.post-re-comment-prev__user-icon(-->
          <!--src="https://pp.userapi.com/c849028/v849028949/ad24a/aiLITs-ybKI.jpg?ava=1"-->
        <!--)-->
        <!--.post-re-comment-prev__user-name Spiridon Robakidze-->
        <!--span &nbspответил. Всего&nbsp-->
        <!--.post-re-comment-prev__count  {{ reComments.length }}-->
        <!--span &nbsp{{ Number(comment.children) < 5 ? 'ответа.' : 'ответов.'}}-->
    <!--template(v-if="comment.children > 2 && showReComment")-->
      <!--post-re-comment-->
    template(v-if="comment.children !== '0' && !reqPending")
      post-re-comment(v-for="reComment in reComments" :reComment="reComment")
      .button-wrap
        span.post-comments-count__show-more(
        v-if="showButton"
        @click="getMoreReComments"
        ) Показать еще
    table-preloader(v-if="reqPending")
</template>

<script>
import router from '@/router';
import PostReComment from '@/components/posts/postReComment.vue';
import { getReCommentsApi } from "@/api/posts";
import TablePreloader from "@/components/preLoaders/tablePreloader";

export default {
  name: 'postComment',
  components: {TablePreloader, PostReComment },
  props: {
    comment: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      postTime: '',
      showReComment: false,
      trimText: true,
      trimTextLength: 300,
      reComments: [],
      reqPending: false,
      limit: 30,
      start: 0,
      count: 0,
      showButton: true,
    };
  },
  mounted() {
    if (this.comment.children !== '0') {
      this.showReCommentsAction();
    }
    this.updateTime();
    setInterval(() => {
      this.updateTime();
    }, 60000);
  },
  methods: {
    getMoreReComments() {
      this.showReComment = !this.showReComment;
      this.showReCommentsAction();
    },
    updateTime() {
      this.postTime = this.$moment(this.comment.created_date).fromNow()
    },
    showReCommentsAction() {
      this.reqPending = true;
      const params = {
        limit: this.limit,
        network_id: this.comment.network_id,
        owner_id: this.comment.owner_id,
        post_id: this.comment.post_id,
        comment_id: this.comment.id,
        start: this.start,
        thread_id: process.env.VUE_APP_THREAD_ID,
      };
      getReCommentsApi(params)
        .then((resp) => {
          this.reComments = [...this.reComments, ...resp.data.commentaries];
          this.count = this.reComments.length ? this.reComments.length : 0;

          if (this.count < this.limit || this.count === parseInt(resp.data.count, 10)) {
            this.showButton = false;
          }

          this.start = this.reComments.length;
          this.reqPending = false;
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            router.push('/login');
          }

          this.reqPending = false;
          return err;
        });
    },
  },
  computed: {
    trimmedText() {
      if (!this.trimText && this.trimTextLength < this.comment.text.length) {
        return this.comment.text;
      }
      if (this.trimText && this.trimTextLength > this.comment.text.length) {
        return this.comment.text;
      }
      return `${this.comment.text.substring(0, this.trimTextLength)} ...`;
    },
  },
};
</script>

<style lang="stylus">
.post-comment
  display flex
  width 100%
  margin-top 1em
  flex-wrap wrap
  &:not(:last-child) .post-comment__body
    border-bottom 1px solid #ccc
  &__user-icon
    width 2.5em
    height 2.5em
    border-radius 50%
    margin .5em 1em 0 0
    flex-shrink 0
  &__body
    flex-grow 1
    padding-bottom 1em
    max-width calc(100% - 4em)
  &__user-name
    color #460303
    margin .3em 0
  &__date
    margin .3em 0
    opacity .6
    display flex
    align-items center
.post-re-comment-prev
  width 100%
  display flex
  align-items center
  margin-left 3.6em
  &:hover
    text-decoration underline
    cursor pointer
  &__user-icon
    width 2.2em
    height 2.2em
    border-radius 50%
    margin 1em 1em 1em 0
  &__user-name
    color #460303
  &__count
    font-weight bold
    color #460303
</style>
